<template>
  <div class="middle-header" :class="{'pure' :pure}">
    <div class="middle-header-content">
      <div class="middle-header-content-row" v-for="item in list" :key="item.key">
        <label>{{item.key}}</label>
        <p>{{item.value}}</p>
      </div>
    </div>
  </div>
</template>

<style lang="stylus" scoped>
@import "../styles/variable.styl";

.middle-header {
  background: linear-gradient(
    $ucar_dark_bg 0%,
    $ucar_dark_bg 50%,
    transparent 50%,
    transparent 100%
  );
  padding: 0 30px;
  &.pure {
    background: transparent;
  }
  .middle-header-content {
    border: 1px solid $ucar_main_border;
    background-color: $ucar_main_bg;
    padding: 30px 48px;
    color: $ucar_font_color;
    font-size: $ucar_font_normal;
    line-height: $ucar_font_normal;

    .middle-header-content-row {
      margin-bottom: 20px;
      display: flex;
      align-items: flex-start;
      min-width: 0;

      label {
        width: 200px;
        line-height: 1.5;
      }

      p {
        flex: 1 1 0;
        line-height: 1.5;
      }

      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}
</style>

<script>
export default {
  props: {
    list: {
      type: Array,
      default: () => {
        return []
      }
    },
    pure: {
      // 背景是否为透明
      type: Boolean,
      default: false
    }
  }
}
</script>
